/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSessionPhase } from './oralExamSessionPhase';
import type { OralExamCohortStateResponseInExamEnteredAt } from './oralExamCohortStateResponseInExamEnteredAt';
import type { OralExamCohortStateResponseStageGate } from './oralExamCohortStateResponseStageGate';
import type { OralExamCohortStateResponseEtag } from './oralExamCohortStateResponseEtag';

/**
 * Slot-embedded cohort state after start or polling.
 */
export interface OralExamCohortStateResponse {
  sessionPhase: OralExamSessionPhase;
  inExamEnteredAt?: OralExamCohortStateResponseInExamEnteredAt;
  admittedBookingIds?: string[];
  stageGate?: OralExamCohortStateResponseStageGate;
  etag?: OralExamCohortStateResponseEtag;
}
